import { StackScreenProps } from "@react-navigation/stack";
import {
  Card,
  FlatActionList,
  Page,
  TextButton,
} from "@towersystems/roam-common-native";
import { Switch } from "react-native";
import { View } from "react-native-ui-lib";
import { SettingsRootParamList } from "../../../../types";
import { formatPercentString } from "../../../../utilities/format-percent-string";
import {
  useGlobalSettingsProvider,
  useMutationUpdateGlobalSettings,
} from "../../../../utilities/global-settings/hooks";
import { moneyToFormattedString } from "../../../../utilities/money";

export interface LaybySettingsRootScreenProps
  extends StackScreenProps<SettingsRootParamList, "LaybySettingsRootScreen"> {}

export const LaybySettingsRootScreen = ({
  navigation,
}: LaybySettingsRootScreenProps) => {
  const globalSettings = useGlobalSettingsProvider();
  const { updateGlobalSettings } = useMutationUpdateGlobalSettings();
  const { laybyEnabled } = globalSettings;

  return (
    <Page title="Layby Settings">
      <Card>
        <FlatActionList
          items={[
            {
              key: "layby_enabled",
              title: "Layby Enabled",
              subTitle: "Enable or disable layby",
              componentRight: () => {
                return (
                  <View>
                    <Switch
                      value={laybyEnabled}
                      onValueChange={() => {
                        updateGlobalSettings({
                          laybyEnabled: !laybyEnabled,
                        }).catch((err) => console.log(err));
                      }}
                    />
                  </View>
                );
              },
            },
            {
              key: "layby_deposit",
              title: "Layby Deposit",
              subTitle: "Set the layby deposit percent",
              componentRight: () => {
                return (
                  <View>
                    <TextButton
                      onPress={() =>
                        navigation.navigate("EditLaybyDepositScreen")
                      }
                    >
                      {formatPercentString(
                        globalSettings.defaultLaybyDepositPercentage.toString()
                      )}
                    </TextButton>
                  </View>
                );
              },
            },
            {
              key: "min_layby_spend",
              title: "Minimum Layby Sale Amount",
              subTitle: "Set the minimum sale amount for a layby",
              componentRight: () => {
                return (
                  <View>
                    <TextButton
                      onPress={() =>
                        navigation.navigate("EditMinLaybySpendScreen")
                      }
                    >
                      {moneyToFormattedString(globalSettings.minLaybySpend)}
                    </TextButton>
                  </View>
                );
              },
            },
          ]}
        />
      </Card>
    </Page>
  );
};
